import api from '@/services/api'

export default {
    fetchRequest(id) {
        return api.get(`api/porting_requests/${id}/`)
            .then(response => response.data)
    },
    fetchRequests(payload) {
        return api.get(`api/porting_requests/`, {params: payload})
            .then(response => response.data)
    },
    fetchComments(payload) {
        return api.get(`api/comments/`, {params: payload})
            .then(response => response.data)
    },
    postRequest(payload) {
        return api.post('api/porting_requests/', payload)
            .then(response => response.data)
    },
    postComment(payload) {
        return api.post('api/comments/', payload)
            .then(response => response.data)
    }
}